import { apiWrapper, apiWrapperNoToken } from '../helper/api-wrapper';

export const login = async (payload) => {
  try {
    const response = await apiWrapperNoToken.post(
      'merchants/session/login',
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const signup = async (payload) => {
  try {
    const response = await apiWrapperNoToken.post(
      'merchants/session/signup',
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const logout = async () => {
  try {
    const response = await apiWrapper.get('merchants/session/logout');

    return response;
  } catch (error) {
    throw error;
  }
};

export const forgotPassword = async (payload) => {
  try {
    const response = await apiWrapper.post(
      'merchants/session/forgot_password',
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (payload) => {
  try {
    const response = await apiWrapperNoToken.patch(
      'merchants/session/reset_password',
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const accountActivation = async (payload) => {
  try {
    const response = await apiWrapperNoToken.patch(
      'merchants/session/activate',
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};
